import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { FiArrowLeft, FiZap } from 'react-icons/fi';
import DocumentSection from '../../components/documents/DocumentSection';

const PDLDocumentDetailPage = ({ 
    pdls, 
    requiredDocuments,
    fournisseurs, 
    userProfile, 
    session
}) => {
    const { pdlId } = useParams();

    const pdl = pdls.find(p => p.id === pdlId);

    if (!pdl) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-2"></div>
                    <p className="text-xs text-gray-600">Chargement du PDL...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-3 p-3">
            <Link 
                to="/dashboard/documents" 
                className="inline-flex items-center text-xs text-gray-600 hover:text-gray-900"
            >
                <FiArrowLeft className="mr-1.5 h-3 w-3" />
                Retour à la liste des PDL
            </Link>

            <div className="flex items-center bg-white rounded shadow border p-3">
                <div className="p-2 bg-blue-100 rounded-full mr-3 flex-shrink-0">
                    <FiZap className="w-5 h-5 text-blue-600" />
                </div>
                <div className="min-w-0 flex-1">
                    <h1 className="text-base font-bold text-gray-900 truncate">{pdl.site_name}</h1>
                    <p className="text-xs text-gray-500 font-mono truncate">{pdl.pdl_number}</p>
                </div>
            </div>

            <div className="space-y-3">
                {requiredDocuments.map(docDef => {
                    const docForPdl = {
                        ...docDef,
                        files: (docDef.files || []).filter(file => file.pdl_id === pdl.id)
                    };

                    return (
                        <DocumentSection
                            key={`${pdl.id}-${docDef.id}`}
                            document={docForPdl}
                            pdl={pdl}
                            fournisseurs={fournisseurs}
                            userProfile={userProfile}
                            session={session}
                            readOnly={true}
                        />
                    );
                })}
            </div>

            {/* Info lecture seule */}
            <div className="bg-blue-50 border border-blue-200 rounded p-3">
                <h3 className="text-sm font-semibold text-blue-900 mb-1">
                    Visualisation en lecture seule
                </h3>
                <p className="text-xs text-blue-700">
                    Consultation des documents pour {pdl.site_name}. 
                    Les modifications ne sont pas disponibles dans cette vue.
                </p>
            </div>
        </div>
    );
};

export default PDLDocumentDetailPage;
